import { Client } from './lib/Client';
import { Endpoint } from './lib/Endpoint';
import { ResourceIdentifier } from './lib/ResourceIdentifier';
const JSONAPI = {
    resource(type, path = type) {
        var _a;
        return _a = class Resource extends ResourceIdentifier {
                constructor(data) {
                    super(data.type, data.id);
                    Object.assign(this, data);
                }
            },
            _a.type = type,
            _a.path = path.replace(/^\/*(.*?)\/*$/, '$1') // remove leading/trailing slash
        ,
            _a.fields = Object.create(null),
            _a;
    },
    client(url, setup = {}) {
        return new Client(url, setup);
    },
    endpoint(client, Resource) {
        return new Endpoint(client, Resource);
    },
};
export default JSONAPI;
export { Client, } from './lib/Client';
export { Endpoint } from './lib/Endpoint';
export { ResourceIdentifier } from './lib/ResourceIdentifier';
export { Attribute, AttributeFlag, Relationship, RelationshipFlag, } from './lib/ResourceField';
export { EntityResult, CollectionResult } from './lib/Result';
//# sourceMappingURL=index.js.map